import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "@/store";

export const selectCreateSixState = (state: RootState) => state.createSix;

export const selectDraft = createSelector(
  selectCreateSixState,
  (state) => state.draft
);

export const selectStep = createSelector(
  selectCreateSixState,
  (state) => state.step
);

export const selectSubmitting = createSelector(
  selectCreateSixState,
  (state) => state.submitting
);

export const selectFieldErrors = createSelector(
  selectCreateSixState,
  (state) => state.fieldErrors
);

export const selectScreenError = createSelector(
  selectCreateSixState,
  (state) => state.screenError
);

export const selectInternalUsers = createSelector(
  selectCreateSixState,
  (state) => state.internalUsers
);

export const selectInvitedUser = createSelector(
  selectCreateSixState,
  (state) => state.invitedUser
);

export const selectExternalUsers = createSelector(
  selectCreateSixState,
  (state) => state.externalUsers
);

export const selectLoadingInternal = createSelector(
  selectCreateSixState,
  (state) => state.loadingInternal
);

export const selectLoadingExternal = createSelector(
  selectCreateSixState,
  (state) => state.loadingExternal
);

export const selectShowSuccessScreen = createSelector(
  selectCreateSixState,
  (state) => state.showSuccessScreen
);

export const selectEditingSixId = createSelector(
  selectCreateSixState,
  (state) => state.editingSixId
);

export const selectIsEditMode = createSelector(
  selectCreateSixState,
  (state) => state.editingSixId !== null
);
